import qs from "qs";

const getOrigin = () => window.location.origin;

const getReturnToUri = () => window.location.href.split(getOrigin())[1];

export const getSeamlessLink = (slug) => {
  const params = {
    toInterfaceId: "dcd",
    destinationUri: `/${slug}`,
    returnToUri: getReturnToUri(),
  };
  return `${getOrigin()}/auth-redirect?${qs.stringify(params)}`;
};
